import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.scss";
import menuData from "../../Layout/MenuData";
// import Logo from "../../assets/icons/acg-logo.png";
import Logo from "../../assets/icons/acg-logo.png";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import { deAuthenticateAll } from "../../utils/store/reducers/Index";
import { clearPersistedData } from "../../utils/store/store";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem } from "@mui/material";

function Sidebar() {
  const location = useLocation();
  const dispatch = useDispatch();
  const handleLogout = () => {
    deAuthenticateAll(dispatch);
    clearPersistedData();
  };

  const accountList = useSelector((state) => state.accountList.data);

  const [isHovered, setIsHovered] = useState(false);
  const [showItems, setShowItems] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    setShowItems(false);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setShowItems(false);
  };

  useEffect(() => {
    let timer;
    if (isHovered) {
      timer = setTimeout(() => {
        setShowItems(true);
      }, 200);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isHovered]);

  return (
    <div
      className={isHovered ? "sidebar expand_sidebar" : "sidebar"}
      id="sidebar"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="topSection">
        {/* <img className="logo" src={Logo} alt="" /> */}
        <div className="logo">
          <img src={Logo} alt="company_logo" style={{ width: "28px" }} />
        </div>
        <div className="sidebar_items">
          {menuData
            ?.filter(
              (menuItem) =>
                !(
                  accountList.length === 0 && menuItem.title === "Account Stats"
                )
            )
            .map((menuItem, index) => (
              <Link key={index} to={menuItem.path} className="sidebar_link">
                <div
                  className={`sidebar_item ${
                    isActive(menuItem, location) ? "active" : ""
                  }`}
                >
                  {menuItem?.icon}
                  {showItems ? <span>{menuItem?.title}</span> : ""}
                </div>
              </Link>
            ))}
          <Link className="sidebar_link" onClick={handleLogout}>
            <div className={`sidebar_item`}>
              <Logout />
              {showItems ? "Logout" : ""}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export function isActive(menuItem, location) {
  const pathname = location.pathname;

  if (
    pathname.includes("/account-analysis") &&
    menuItem.path === "/account-stats"
  ) {
    return true;
  }

  if (menuItem.path === "/") {
    return pathname === "/";
  } else if (menuItem.path === "/account-anlysis/") {
    return pathname === "/account-anlysis/";
  }

  return pathname.includes(menuItem.path);
}

export default Sidebar;
